// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../shared/action-creators/busy-counter';
import actions from '../../shared/actions-list';
import {getLinks} from '../../shared/repositories';
import {getStore} from '../../store-factory';

export const readLinks = () =>

    async dispatch => {

        const {getState} = getStore();

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLinks(getState().user.details.settings.language.primaryLanguage.key);

            dispatch({
                data,
                type: actions.UPDATE_LINKS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/app/action-creators/links.js